export const MENU_STATUS= [
    "ALL",
    "NEW",
    "SENT",
    "ACCESSING",
    "NEW PARTNER",
    "PARTNER",
    "ON HOLD",
    "REFUSED",
]